module.exports = __webpack_public_path__ + "img/news1.906d41ba.jpg";